import { areaCategoryValidator, screenValidator, seatAvailabilityValidator, seatLayoutValidator, showtimeAreaCategoryValidator } from '@vista-digital/ocapi-utilities';
import { Validator } from '@vista-digital/validator';
import { seatSelectionLimitsValidator } from './seat-selection-limits';
export const seatingDataValidator = Validator.object({
    seatLayout: seatLayoutValidator,
    areaCategories: Validator.array({ items: areaCategoryValidator }),
    showtimeAreaCategories: Validator.optional(Validator.array({ items: showtimeAreaCategoryValidator })),
    seatAvailabilities: Validator.array({ items: seatAvailabilityValidator }),
    reservedSeatIds: Validator.array({ items: Validator.nonEmptyString }),
    friendSeatIds: Validator.optional(Validator.array({ items: Validator.nonEmptyString })),
    seatSelectionLimits: seatSelectionLimitsValidator,
    screen: screenValidator,
    siteId: Validator.nonEmptyString
});
//# sourceMappingURL=seating-data.js.map